import {
  Breakpoints,
  Text,
  TokenTextColor,
  styled,
} from '@volkswagen-onehub/components-core';
import { PropsWithChildren, ReactNode } from 'react';

const StyledText = styled(Text)(
  ({ theme }) => `
  color: ${theme.colors.content.inverted};
  opacity: 0.3;
  width: max-content;
  font-size: 100vw;
  line-height: 1;
  margin-bottom: 0;

  @media (min-width: ${Breakpoints.b960}px) {
    font-size: 50vw;
  }

  @media (min-width: ${Breakpoints.b2560}px) {
    font-size: 900px;
  }
`);

interface HeaderProps {
  children?: React.ReactNode
}

const HeaderBackgroundText = ({ children }: HeaderProps) => {
  return (
    <StyledText color={TokenTextColor.inherit} bold>
      {children}
    </StyledText>
  );
};

export default HeaderBackgroundText;
